<template>
  <div class="nsale_">
    <div>
      <div class="list_" v-if="list.length != 0">
        <div
          class="item_"
          v-for="(item, index) in list"
          :key="index"
          @click="toPreview(index, item)"
        >
          <div class="item_1">
            <img class="item_1img" :src="item.originalImageUrl" alt="poster" />
            <!-- <div class="saveTip">
              <span>长按可保存海报</span>
            </div> -->
          </div>
          <div class="item_2">
            <img class="item_2img" :src="codeUrl" alt="code" />
            <div class="scale">
              <p class="txt txt1">邀请码</p>
              <p class="txt txt2">{{ defaultInfo.loginName }}</p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="nullPost" style="padding-top: 150px;">
        <div class="null_ null_1">
          <img :src="codeUrl" alt="no" />
          <div class="invite-code">
            <p class="txt txt1">邀请码：</p>
            <p class="txt txt2">{{ defaultInfo.loginName }}21312312</p>
          </div>
        </div>
        <cube-button
          id="copy"
          @click="shareRegisterLink"
          class="btn_"
          :data-clipboard-text="inviteRegisterLink"
          >分享注册链接</cube-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
import Clipboard from "clipboard";
export default {
  data() {
    return {
      nullPost: false,
      nullTemp: false,
      appId: "", //商城id
      bullTemp: "",
      tempInfo: {
        tempName: ""
      },
      inviteUrl: "",
      userId: "",
      identify: "",
      codeUrl: "",
      defaultInfo: {},
      list: [],
      inviteRegisterLink: "",
      clipboard: null
    };
  },
  filters: {
    filterTeam(val) {
      if (val == "" || val == null) {
        return bullTemp;
      } else {
        return val;
      }
    }
  },
  mounted() {
    // alert(navigator.userAgent)
    this.getAppId();
    this.hideOptionMenu();
    this.userId = this.$route.query.userId;
    this.identify = this.$route.query.identify; //获取微信分享配置所需参数
    localStorage.setItem("i_", this.identify); //获取微信分享配置所需参数
    this.getToken().then(() => {
      this.getUserDetailByUserId();
      this.queryDevelopTeamByUserId();
    });
    this.clipboard = new Clipboard("#copy");
  },
  methods: {
    getAppId() {
      //获取appid
      this.appId = this.$route.query.appId;
      localStorage.setItem("a_id", this.appId);
    },
    verifyBSAppId() {
      //接口判断appid
      api.verifyBSAppId().then(res => {
        this.isBSApp = res.data.content;
      });
    },
    queryLink() {
      let origin = "http://wx.run4wd.com";
      if (/ssish/.test(location.href)||/yutai365/.test(location.href)) {
        origin = "http://wx.ssish.com"
      }
      this.inviteRegisterLink = `${origin}/mnRegist?inviteCode=${this.postInfo.loginName}&appId=${localStorage.getItem("a_id")}`;
      this.$nextTick(function() {
        this.$forceUpdate();
      });
    },
    hideOptionMenu() {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function onBridgeReady() {
          WeixinJSBridge.call("hideOptionMenu");
        }
      );
    },
    showOptionMenu() {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function onBridgeReady() {
          WeixinJSBridge.call("showOptionMenu");
        }
      );
    },
    getUserDetailByUserId() {
      api.getUserDetailByUserId(this.userId).then(res => {
        this.defaultInfo = res.data.content;
        this.queryLink();
      });
    },
    addAccount() {
      let urlArr = this.inviteUrl.split("/");
      let id = urlArr[urlArr.length - 1];
      console.log(urlArr);
      // this.$router.push({
      //   path: `/nsale/register/${id}?userId=${this.userId}`
      // });
      window.location.href =
        window.location.origin +
        `/m/nsale/register/${id}?userId=${this.userId}`;
    },
    getToken() {
      return api.getToken({ userId: this.userId }).then(res => {
        localStorage.setItem("token", res.data.content);
      });
    },
    getRegisterLink() {
      return api
        .getRegisterLink(this.tempInfo.id)
        .then(res => res.data)
        .then(data => {
          return data.content;
        })
        .then(url => {
          this.inviteUrl = url;
          import("jr-qrcode").then(jrQrcode => {
            // 模块方法调用，传入字符串，获取 base64 编码的图片 URL
            var imgBase64 = jrQrcode.getQrBase64(url);
            this.codeUrl = imgBase64;
          });
        });
    },
    transformUrl(url) {
      console.log("url -> ", url);
      const pathname = new URL(url).pathname;
      // let origin = "http://mall.run4wd.com"; // 支持跨域的测试环境图片

      let origin = window.location.origin;
      const imgUrl = origin + pathname; // 转化后跨域的图片路径
      return imgUrl;
    },
    queryDevelopTeamByUserId() {
      let data = {
        appId: this.appId
      };
      api.queryDevelopTeamByUserId(data).then(res => {
        if (!res.data.content || res.data.content.length == 0) {
          this.nullPost = true;
        }
        this.list = res.data.content.map(item => {
          return {
            ...item,
            originalImageUrl: this.transformUrl(item.originalImageUrl)
          };
        });
      });
    },
    showTempPicker() {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: "选择",
          alias: {
            value: "id",
            text: "tempName"
          },
          data: [this.column1],
          onSelect: this.selectHandle
        });
      }
      this.picker.show();
    },
    selectHandle(selectedVal, selectedIndex, selectedText) {
      console.log(selectedVal, selectedIndex, selectedText);
      this.tempInfo = {
        tempName: selectedText[0],
        id: selectedVal[0]
      };
      this.getRegisterLink();
      console.log(this.tempInfo, "this.tempInfo");
    },
    toPreview(index, item) {
      this.$router.push({ path: `/nsale/previewCUser/${this.tempInfo.id}` });
      this.setInfo(item);
    },
    setInfo(item) {
      let postInfo = {
        img: item.originalImageUrl,
        name: this.defaultInfo.name,
        loginName: this.defaultInfo.loginName,
        qrcode: this.codeUrl
      };
      localStorage.setItem("postInfo", JSON.stringify(postInfo));
    },
    // 分享注册链接
    shareRegisterLink() {
      const self = this
      this.clipboard = new Clipboard("#copy");
      this.clipboard.on("success", function(e) {
        self.clipboard = null;
        self.$toast("链接复制成功");
      });

      this.clipboard.on("error", function(e) {
        console.error("Action:", e.action);
        console.error("Trigger:", e.trigger);
        self.$toast("链接复制失败");
      });
    },
  }
};
</script>

<style scoped lang="scss">
.nsale_ {
  background: rgba(245, 245, 245, 1);
  min-height: 100vh;
  position: relative;
  .btn_ {
    width: 305px;
    height: 50px;
    background: rgba(255, 74, 53, 1);
    border-radius: 5px;
    margin: 40px auto 10px;
  }
  .head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 60px;
    padding: 0 15px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .head_ {
      font-size: 15px;
      color: rgba(51, 51, 51, 1);
      position: relative;
      .i_img {
        position: absolute;
        right: 10px;
        top: 12px;
        height: 7px;
        width: auto;
      }
    }
    .head_2 {
      width: 160px;
      height: 30px;
      background: #f5f5f5;
      border-radius: 5px;
      display: flex;
      align-items: center;
    }
    .head_3 {
      width: 100px;
      height: 30px;
      line-height: 30px;
      background: rgba(255, 74, 53, 1);
      border-radius: 5px;
      font-size: 13px;
      color: rgba(255, 255, 255, 1);
    }
  }

  .list_ {
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 8px;
    .item_ {
      width: 170px;
      margin-top: 10px;
      .item_1 {
        height: 243px;
        position: relative;
        .item_1img {
          width: 100%;
          height: 100%;
        }
        .saveTip {
          width: 100%;
          height: 20px;
          line-height: 20px;
          background: rgba(0, 0, 0, 1);
          opacity: 0.4;
          position: absolute;
          bottom: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            font-size: 12px;
            color: rgba(255, 255, 255, 1);
            opacity: 0.5;
            // transform: scale(0.7, 0.7);
          }
        }
      }
      .item_2 {
        background: #fff;
        height: 56px;
        display: flex;
        align-items: center;
        font-size: 12px;
        color: rgba(102, 102, 102, 1);
        .scale {
          // transform: scale(0.7, 0.7);
          margin-left: 5px;
          width: 70%;
        }
        .item_2img {
          margin-left: 5px;
          width: 30%;
          height: auto;
        }
        .txt {
          text-align: left;
          font-size: 8px;
        }
        .txt1 {
          margin-bottom: 4px;
          font-weight: bold;
          font-size: 16px;
        }
        .txt2 {
          margin: 0 6px 0 0;
          line-height: 12px;
        }
      }
    }
  }

  .null_ {
    padding-top: 70px;
    font-size: 13px;
    color: rgba(153, 153, 153, 1);
    img {
      height: 130px;
      width: auto;
    }
    .invite-code {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    }
    .txt {
      text-align: left;
      font-size: 18px;
      font-weight: bold;
    }
    .txt1 {
      margin-right: 4px;
      color: #333333;
    }
    .txt2 {
      line-height: 20px;
      color: #409eff;
    }
  }
  .null_1 {
    margin: 0 auto;
    padding-top: 0;
    width: 345px;
    height: 345px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .nullTxt1 {
      font-size: 17px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
  }
}
</style>
